import * as React from "react";
const SvgWorkspaceIcon = ({ width, height, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    data-name="Layer 1"
    viewBox="0 0 48 35.89"
    width={width || undefined}
    height={height ? height : "auto"}
    fill="currentColor"
    {...props}
    className={`svg-icon shake-two-icon-target ${props.className || ""}`}
    style={{
      transformOrigin: "center",
      ...props.style,
      ...(width ? { width: width } : {}),
      ...(height ? { height: height } : {}),
    }}
  >
    <path d="M46.86 0H1.14A1.13 1.13 0 0 0 0 1.12v26.05a1.14 1.14 0 0 0 1.14 1.12h19.67v4.43h-6.13a1.13 1.13 0 0 0-1.14 1.11v.94a1.13 1.13 0 0 0 1.14 1.12h18.64a1.13 1.13 0 0 0 1.14-1.12v-.94a1.13 1.13 0 0 0-1.14-1.11h-6.13v-4.43h19.67A1.14 1.14 0 0 0 48 27.17v-26A1.13 1.13 0 0 0 46.86 0m-1 25.77H1.54V1.61h44.37Z" />
  </svg>
);
export default SvgWorkspaceIcon;
